const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/**
 * Generates the Data Dictionary schema for a CardListComponent.
 * This is a view-only block that displays records in a card layout.
 * It creates a relation entry for route access checks but should NOT override
 * canonical required arrays defined by Forms.
 * @param {Object} hNode The hierarchical node for this block.
 * @param {Object} context The context for schema generation.
 * @param {Object} parentAccessRestrictions The access restrictions from the parent.
 * @returns {Array} The Data Dictionary and Type Definition.
 */
function asDataDictionary(hNode, context, parentAccessRestrictions) {
    const { namespace, relation, children, securityModifier } = hNode;

    const accessRestrictions = actionUtils.getNodeAccessRestrictions(hNode, context, parentAccessRestrictions);
    const normalizedAction = actionUtils.normalizeAction('list');

    if (accessRestrictions.hidden) return [{}, {}];

    let [_subDataDictionary = {}, _partialTypeDefinition = {}] = (children || []).reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(
                child,
                context,
                accessRestrictions
            );
            return [
                moduleRegistration.mergeSubDataDictionaries(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition)
            ];
        },
        [{}, {}]
    );

    // Build relation entry for route access checks
    // Note: This is a view-only block so we don't set required - that's defined by Forms
    const relationSchema = {
        type: 'object',
        properties: { ..._partialTypeDefinition },
        'x-accessRestrictions': accessRestrictions,
        'x-forAction': normalizedAction
    };

    // Use relation-aware merge to avoid overwriting canonical required arrays
    const subDataDictionary = moduleRegistration.mergeSubDataDictionaries(
        {
            [namespace]: {
                [relation]: relationSchema
            }
        },
        _subDataDictionary
    );

    return [subDataDictionary, {}];
}

module.exports = { asDataDictionary };
